import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import OriginalsShopCard from '../../../../ShopCard/OriginalsShopCard';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

import s from './OriginalSource.scss';

export interface Props {
  block: RelatedBlock;
  deviation?: PapiDeviation;
  withHeader?: boolean;
  className?: string;
}

const OriginalSource: React.FC<Props> = ({
  block,
  deviation: parentDeviation,
  className,
  withHeader,
}) => {
  const custom_exclusives = useFlag('custom_exclusives');
  const { deviations } = block;

  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    MeasuredCookieType.DEVIATION_SIDEBAR,
    {
      cookieDim: 'width',
    }
  );

  if (!custom_exclusives || !deviations || deviations.length === 0) {
    return null;
  }
  const deviation = deviations[0];

  // The block deviation's completedOrdersCount comes from deviations_originals_responses
  // which doesn't decrease on delivery revoke. The parent's extended.originals uses
  // deviations_originals_deliveries which does, so prefer it when available.
  // Only apply this when showing the source of a delivery (not for related originals).
  const completedOrdersCount =
    block.contentType === 'monetization_promotion_originals_delivered'
      ? parentDeviation?.extended?.originals?.completedOrders?.total
      : undefined;

  return (
    <SidebarBlockWrapper
      deviation={deviation}
      block={block}
      className={className}
      noHeader={!withHeader}
    >
      <div ref={ref} className={s['root']}>
        <OriginalsShopCard
          key={deviation.deviationId}
          deviation={deviation}
          width={measuredContainer.width}
          withAuthorDetails
          completedOrdersCount={completedOrdersCount}
        />
      </div>
    </SidebarBlockWrapper>
  );
};
OriginalSource.displayName = 'OriginalSource';

export default OriginalSource;
